import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {UntypedFormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FileUploader, ParsedResponseHeaders, FileItem, FileUploadModule} from 'ng2-file-upload';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {TypesService, ApplicationService, FormBuilderService, NotificationService, FileService } from '../../../services';
import {environment} from '../../../../environments/environment';
import {IndividualDocumentModel} from '../../../models/widgets/documents-upload-model';
import {OAuthService} from 'angular-oauth2-oidc';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {MatInputModule} from '@angular/material/input';
import {MatOptionModule} from '@angular/material/core';
import {NgFor, NgIf, NgClass} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCardModule} from '@angular/material/card';
import {DataHandlerService} from '../../../services/data-handler.service';
import * as _ from 'lodash';
import { lastValueFrom } from 'rxjs';

const COMPANY = 'company';
const PERSON = 'person';
const TRUST = 'trust';
const APPLICATION = {id: 1, text: 'application'};
const APPLICANT = {id: 2, text: 'applicant'};
const SECURITY = {id: 3, text: 'security'};

@Component({
  selector: 'app-docs-upload',
  templateUrl: './documents-upload.component.html',
  styles: [],
  standalone: true,
  imports: [MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule,
    MatSelectModule, NgFor, MatOptionModule, MatInputModule, NgIf, MatChipsModule, MatIconModule,
    FileUploadModule, NgClass, MatButtonModule]
})

export class DocumentUploadComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isHomeLoan: any;
  @Input() public personList: any;
  @Input() public companyList: any;
  @Input() public trustList: any;
  @Input() public securityDetails: any;
  @Input() public step: any;
  @Input() public activeStep: any;

  public uploader: FileUploader;
  public documentTypeSlug = 'document-types';
  public documentTypeCategorySlug = 'document-categories';
  public getDocTypesParameter = 'vx';
  public documentCategoryID = 1;
  private uploadUrl = environment.api.submission + '/files';
  public maxFileSizeMb = 50; // Set it to 50 by default

  public securities: any = [];
  public parties: any = [];
  public uploadData: any = [];
  public selectedDocType: any;
  public allDocTypes = [];
  public filesList = [];
  public showUploader = false;
  public showFileList = false;
  public loading = false;
  public hasDropZoneOver = false;
  public showSecurities = false;
  public showParties = false;
  public documentArray: any;

  public ommittedHomeLoanDocTypes: any = [
    'insaxaq',
    'dti',
    'dd',
    'emp',
    'mia',
    'mip',
    'motcos',
    'motinv',
    'pof',
    'pslip',
  ];

  constructor(private typesService: TypesService,
              public filesService: FileService,
              private formBuilderService: FormBuilderService,
              private oauthService: OAuthService,
              private notificationService: NotificationService,
              private applicationService: ApplicationService,
              public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.populateDocTypes();
    this.resetUpload();
    this.initUploader();
    this.checkPacketIdentities();
  }

  ngOnChanges(changes) {
    this.documentArray = this.formGroup.get('files');

    if (changes.activeStep && changes.activeStep.currentValue && changes.activeStep.previousValue !== changes.activeStep.currentValue) {
      this.checkPacketIdentities();
    }

    if (changes['formGroup'] && changes['formGroup']['firstChange']) {
      if (this.documentArray.value.length > 0) {
        this.showFileList = true;
      }
    }
  }

  checkPacketIdentities() {
    const persons = (this.personList && this.personList.value.length > 0) ?
      this.personList.value.map((value, index) => {
        const person: any = {};
        person.name = `${value.firstName || ''} ${value.middleName ? `${value.middleName} ` : ''}${value.lastName || ''}`;
        person.id = `${PERSON}-${index}`;
        return person;
      }) : [];

    const trusts = (this.trustList && this.trustList.value.length > 0) ?
      this.trustList.value.map((value, index) => {
        const trust: any = {};
        trust.name = value.trustName;
        trust.id = `${TRUST}-${index}`;
        return trust;
      }) : [];

    const companies = (this.companyList && this.trustList.value.length > 0) ?
      this.companyList.value.map((value, index) => {
        const company: any = {};
        company.name = value.companyName;
        company.id = `${COMPANY}-${index}`;
        return company;
      }) : [];

    this.parties = persons.concat(trusts, companies);

    if (this.securityDetails && this.securityDetails.length > 0 && this.isHomeLoan) {
      this.securities = this.securityDetails.map((value, index) => {
        const security: any = {};
        security.name = (value.securityAddress) ? value.securityAddress.flatSearch : 'TBA';
        security.id = `collateral-${index}`;
        return security;
      });
    } else if (!this.isHomeLoan) {
      this.dataHandlerService.getSecuredAsset()
        .subscribe((result: any) => {
          if (result && result.vehicle && result.vehicle.description) {
            this.securities = [{
              name: result.vehicle.description,
              id: 'collateral-0'
            }];
          }
        });
    }

    console.log('checkPacketIdentities', this.parties, this.securityDetails, this.securities);
  }

  public populateDocTypes() {
    this.filesService.getDocumentTypesWithJobType().subscribe((results) => {
      const documentTypes = results || [];
      // sort documentTypes asc manner

      this.allDocTypes = _.sortBy(documentTypes, ['text']) || [];

      // if product category home-loan remove docTypes in this list ommittedHomeLoanDocTypes
      if (this.isHomeLoan) {
        const filteredAllDocTypes = _.filter(this.allDocTypes, doctype => !this.ommittedHomeLoanDocTypes.includes(doctype.id));
        this.allDocTypes = filteredAllDocTypes;
      }
    });
  }

  public initUploader() {
    this.uploader = new FileUploader({
      url: `${this.uploadUrl}`,
      authToken: `Bearer ${this.oauthService.getAccessToken()}`,
    });

    this.uploader.onBuildItemForm = (item, form) => {
    };

    this.uploader.onAfterAddingFile = (item: FileItem) => {

      try {
        // TODO: filter by extensions?

        // check file size
        const fileSize = item.file.size / 1024 / 1024; // MB
        if (fileSize > this.maxFileSizeMb) {
          console.log('[uploader]', '[ERROR]', 'Max file size exceeded.');
          this.notificationService.toast('warn', `Exceed the ${this.maxFileSizeMb} MB file size limit.`);
          // TODO: show error
          return;
        }
      } catch (e) {
        console.log('[uploader]', '[ERROR]', e);
      }
      this.uploader.uploadItem(item);
    };

    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      const docType = this.selectedDocType.id;
      const comments = this.formGroup.value.comments;
      const name = item.file.name;
      this.uploader.options.url = this.uploadUrl + '/' + encodeURI(name);
      this.loading = true;
      const headers: any = [
        {
          name: 'x-fmc-file-type',
          value: docType
        },
        {
          name: 'x-fmc-file-comment',
          value: comments
        },
      ];
      this.uploader.setOptions({
        url: this.uploadUrl + '/' + encodeURI(name),
        headers
      });
    };

    this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      let uploadData: any;

      try {
        uploadData = JSON.parse(response);
        if (uploadData && typeof uploadData === 'object' && uploadData.code === "ServiceUnavailable") {
          this.notificationService.toast('warn', 'Error uploading file. Please try again later.');
          return;
        }
        const data = {
          key: uploadData,
          origName: item.file.name,
        };

        data['description'] = this.selectedDocType.text;
        data['documentTypeCode'] = this.selectedDocType.id;
        data['party'] = null;
        data['security'] = null;
        this.uploadData.push(data);
      } catch (e) {
        console.log('[onCompleteItem]', '[ERROR]', e);
        // TODO: show error?
      }
    };

    this.uploader.onCompleteAll = () => {
      this.loading = false;
      this.uploader.clearQueue();
      this.setFormError();
    };

    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      // TODO: show errors?
      this.loading = false;
      console.error('Error during file upload', response);
      this.notificationService.toast('warn', 'Error uploading file. Please try again later.');
    };
  }

  public setFormError() {
    if (this.uploadData.length) {
      this.formGroup.setErrors({upload: true});
    } else {
      this.formGroup.setErrors(null);
    }
  }

  public addFileToList(formGroup: any) {
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.invalid) {
      console.log('this.formGroup', this.formGroup);
      console.log('this.formGroup rawValue', this.formGroup.getRawValue());
      this.notificationService.toast('warning', 'Error adding file to list of documents');
      return;
    }

    if (this.uploadData) {
      this.addFile();

      formGroup.get('securities').clearValidators();
      formGroup.get('securities').updateValueAndValidity(true);

      formGroup.get('parties').clearValidators();
      formGroup.get('parties').updateValueAndValidity(true);
    }
    this.setFormError();
  }

  public resetUpload() {
    this.formGroup.get('parties').patchValue(null);
    this.formGroup.get('securities').patchValue(null);
    this.formGroup.get('documentType').patchValue('');
    this.formGroup.get('comments').patchValue('');
    this.showUploader = false;
    this.showSecurities = false;
    this.showParties = false;
    this.setFormError();
  }

  public fileOverBase(event) {
    this.hasDropZoneOver = event;
  }

  public updateSelectedDocType(id: any, formGroup: any) {
    this.showUploader = true;
    const foundType = _.find(this.allDocTypes, doctype => _.lowerCase(doctype.id) === _.lowerCase(id));
    this.selectedDocType = (foundType) ? foundType : null;

    formGroup.get('parties').patchValue(null);
    formGroup.get('securities').patchValue(null);

    if (_.has(foundType, 'ext.entityType')) {
      const entityType = foundType.ext.entityType;
      this.showSecurities = (entityType && entityType === SECURITY.text);
      this.showParties = (entityType && entityType === APPLICANT.text);

      if (this.showParties) {
        formGroup.get('parties').setValidators(Validators.required);
        formGroup.get('parties').markAsTouched();
        formGroup.get('parties').updateValueAndValidity(true);

        formGroup.get('securities').clearValidators();
        formGroup.get('securities').updateValueAndValidity(true);
      }

      if (this.showSecurities) {
        formGroup.get('securities').setValidators(Validators.required);
        formGroup.get('securities').markAsTouched();
        formGroup.get('securities').updateValueAndValidity(true);

        formGroup.get('parties').clearValidators();
        formGroup.get('parties').updateValueAndValidity(true);
      }

    } else {
      formGroup.get('parties').clearValidators();
      formGroup.get('parties').updateValueAndValidity(true);

      formGroup.get('securities').clearValidators();
      formGroup.get('securities').updateValueAndValidity(true);

      this.showSecurities = false;
      this.showParties = false;
    }
  }

  public deleteTempDoc(index) {
    this.uploadData.splice(index, 1);
    this.setFormError();
  }

  // chip actions
  public deleteDoc(index) {
    const data = this.documentArray.at(index).value;
    if (data && data.checksum) {
      this.applicationService.deleteAttachment(data).subscribe(a => {
        this.documentArray.removeAt(index);
        if (this.documentArray.value.length < 1) {
          this.showFileList = false;
        }
      }, (error: any) => {
        console.log('deleteDoc error', error);
      });
    } else {
      this.documentArray.removeAt(index);
    }
  }

  public addFile() {
    console.log('addFile', this.securities);
    const tempUploadData: any = this.uploadData;

    tempUploadData.forEach((file: any) => {
      file['comments'] = this.formGroup.get('comments').value;
      file['description'] = this.selectedDocType.text;
      file['documentTypeCode'] = this.selectedDocType.id;

      if (this.formGroup.get('parties').value && this.formGroup.get('parties').value.length > 0) {
        this.formGroup.get('parties').value.forEach((party: any) => {
          // parties form value gets converted into a split object, concatenate into a string for file processing
          if (typeof party !== 'string') {
            party = Object.values(party).join('');
          }
          file['party'] = party;
          this.addToDocumentArray(file);
        });
      } else if (this.formGroup.get('securities').value && this.formGroup.get('securities').value.length > 0) {
        this.formGroup.get('securities').value.forEach((security: any) => {
          file['security'] = security;
          this.addToDocumentArray(file);
        });
      } else {
        this.addToDocumentArray(file);
      }
    });

    this.resetUpload();
    this.uploadData = [];
  }

  addToDocumentArray(file) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new IndividualDocumentModel());
    fg.setValue(file);
    this.formBuilderService.setValidationRules(new IndividualDocumentModel(), fg);
    this.documentArray.push(fg);

    console.log('this.documentArray', this.documentArray, file);
  }
}
